import { EventEmitter, Output } from '@angular/core';
import { SimpleChanges } from '@angular/core';
import { Component, Input, OnInit, forwardRef, OnDestroy, OnChanges } from '@angular/core';
import {
	FormGroup,
	NG_VALUE_ACCESSOR
} from '@angular/forms';
import { PAX_TYPE_SPONSOR } from '@ibe.config';
import { takeWhile } from 'rxjs/operators';

@Component({
	selector: 'app-select-beneficiary',
	templateUrl: './select-beneficiary.indra.component.html',
	styleUrls: ['./select-beneficiary.component.scss'],
	host: { class: 'app-select-beneficiary' },
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			multi: true,
			useExisting: forwardRef(() => INDRASelectBeneficiaryComponent)
		}
	]
})
export class INDRASelectBeneficiaryComponent implements OnInit, OnChanges, OnDestroy {
	@Input() id;
	@Input() label;
	@Input() arialabel : String = '';
	@Input() placeholder;
	@Input() required = false;
	@Input() inputValue: String = '';
	@Input() inputOptions = [
		{
			value: String,
			label: String,
			disabled: Boolean,
			prefix: String,
			type: String
		}
	];
	@Input() disabled = false;
	@Input() parentForm: FormGroup = null;
	@Input() formGroupName = null;
	@Input() formControlName = null;
	@Input() errorMessage;
	@Input() hasError;
	@Input() isReset:boolean;

	@Output() onReset = new EventEmitter<any>();
	
	selectUndefinedOptionValue:any;
	showPlaceholder: boolean = false;

	@Input()
	// get accessor
	get value(): any {
		return this.inputValue;
	}

	// set accessor including call the onchange callback
	set value(v: any) {
		if (v !== this.inputValue) {
			this.inputValue = v;
			this.onChange(v);
		}
	}

	is_unselected = false;
	is_open = false;
	isAlive = true;
	PAX_TYPE_SPONSOR = PAX_TYPE_SPONSOR;

	constructor() { }

	ngOnInit() {
		this.is_unselected = this.placeholder !== undefined && (this.inputValue === (null || ''));
		if (this.parentForm) {
			if (this.parentForm.get(this.formControlName).value) {
				this.is_unselected = false;
			}
			this.parentForm.get(this.formControlName).valueChanges
				.pipe(takeWhile(() => this.isAlive))
				.subscribe(value => {
					if (value == null) {
						this.is_unselected = true;
						this.handleSelectChange();
					}
					/*
					if (value == null) {
						this.is_unselected = true;
					} else {
						this.is_unselected = false;
					}
					this.handleSelectChange();
					*/
				});
		} else if (this.inputValue === '') {
			this.inputValue = null;
		}
	}

	ngOnChanges(changes: SimpleChanges): void {
		if(this.isReset){
			this.showPlaceholder = true;
			this.inputValue = null;
			this.handleSelectChange();
			this.isReset = false;
			this.onReset.emit(this.isReset);
		}
	}


	hasLabel() {
		return this.label !== undefined;
	}
	
	printLabel() {
		return this.label;
	}

	hasPlaceholder() {
		return this.placeholder !== undefined && this.is_unselected;
	}
	printPlaceholder() {
		return this.placeholder;
	}

	/**
	 * @returns styles for select wrapper
	 */
	INDRA_selectWrapperStyles() {
		const result = [];

		if (this.is_open) result.push('is-open');
		if (this.disabled) result.push('is-disabled');
		if (this.hasPlaceholder()) result.push('is-unselected');

		return result.join(' ');
	}

	/**
	 * @returns styles for select
	 */
	INDRA_selectStyles() {
		return {
			'is-unselected': this.hasPlaceholder(),
			'has-error': this.hasError
		};
	}

	handleSelectChange() {
		this.is_open = false;
		if (this.is_unselected && (this.inputValue !== (null || ''))) {
			this.is_unselected = false;
		}
	}

	handleSelectClick() {
		this.is_open = true;
	}

	handleSelectBlur() {
		this.is_open = false;
	}

	change($event) {
		this.inputValue = $event.target.value;
		if (this.parentForm) this.parentForm.get(this.formControlName).setValue(this.inputValue);
		this.handleSelectChange();
	}

	get INDRA_printID() {
		return this.id;
	}

	get INDRA_showError() {
		return this.hasError;
	}

	// Function to call when the rating changes.
	onChange = (value) => { };

	// Function to call when the input is touched (when a star is clicked).
	onTouched = () => { };

	// Allows Angular to update the model (rating).
	// Update the model and changes needed for the view here.
	writeValue(value): void {
		this.onChange(value);
	}

	// Allows Angular to register a function to call when the model (rating) changes.
	// Save the function as a property to call later here.
	registerOnChange(fn: (rating: number) => void): void {
		this.onChange = fn;
	}

	// Allows Angular to register a function to call when the input has been touched.
	// Save the function as a property to call later here.
	registerOnTouched(fn: () => void): void {
		this.onTouched = fn;
	}

	// Allows Angular to disable the input.
	setDisabledState(isDisabled: boolean): void {
		this.disabled = isDisabled;
	}

	INDRA_printError() {
		return this.errorMessage;
	}

	INDRA_isRequired() {
		return this.required;
	}


	ngOnDestroy(): void {
		this.isAlive = false;
	}
}
